export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // mobile menu panel
    $('#mobile-menu-toggle').on('click', function () {
      $('#mobile-menu').addClass('active');
    });

    $('#close-mobile-menu, #mobile-menu').on('click', function () {
      $('#mobile-menu').removeClass('active');
      setTimeout(() => {
        $('.nav-mobile .menu-item-has-children').removeClass('active');
        $('.nav-mobile .menu-item-has-children .sub-menu').addClass('close');
        $('.nav-mobile .menu-item-has-children .sub-menu').slideUp(400);
      }, 300);
    });
    $('.mobile-menu__panel-inner').on('click', function (event) {
      event.stopPropagation();
    });

    // POST FILTER ////////////////////////////////////////////////////////
    $('.post-filter__toggle-list').on('click', function (e) {
      e.stopPropagation();
      $('.post-filter').removeClass('active');
      const filterWrapper = $(this).parents('.post-filter');
      filterWrapper.addClass('active');
    });
    // separate filter toggle to show/hide filter list
    $('.post-filter__toggle').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).parents('.post-filter').removeClass('active');
    });
    // hide all filter post on click outside it
    $(document).on('click', function (e) {
      e.stopPropagation();
      if ($(e.target).is('.post-filter') === false) {
        $('.post-filter').removeClass('active');
      }
    });
    // POST FILTER //////////////////////////////////////////////////////// END
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js